import React, { useCallback, useEffect, useRef } from "react";
import {
    useSelector } from "react-redux";
import {
  CART_INITIAL_STATE,
  test_environment_mode
} from "../../constants/constant";

const DEFAULT_COUPON_APP_URL = process.env.REACT_APP_COUPON_APP_URL || "https://coupon.billmitra.in/";
// CouponClientConfig.clientKey is stored as a string in Mongo. Each integrating
// website can supply its own value through props or REACT_APP_COUPON_CLIENT_ID.
const DEFAULT_COUPON_CLIENT_ID =
  process.env.REACT_APP_COUPON_CLIENT_ID || (test_environment_mode ? "2" : "1");

const CouponManagementFrame = ({
  couponAppUrl = DEFAULT_COUPON_APP_URL,
  couponClientId = DEFAULT_COUPON_CLIENT_ID,
}) => {
  const frameRef = useRef(null);
  const activeShop = useSelector((state) => state.setActiveShopHashReducer.activeShopHash);
  const couponAppOrigin = new URL(couponAppUrl, window.location.origin).origin;
  const couponEmbeddedUrl = (() => {
    const url = new URL(couponAppUrl, window.location.origin);
    url.searchParams.set("embedded", "1");
    url.searchParams.set("parentOrigin", window.location.origin);
    return url.toString();
  })();

  const sendSession = useCallback(() => {
    if (!frameRef.current?.contentWindow || !activeShop?.id || !CART_INITIAL_STATE.apiToken) {
      console.error("Coupon session was not sent", {
        iframeReady: Boolean(frameRef.current?.contentWindow),
        hasShopHash: Boolean(activeShop?.id),
        hasApiToken: Boolean(CART_INITIAL_STATE.apiToken),
      });
      return;
    }
    frameRef.current.contentWindow.postMessage(
      {
        type: "SNP_COUPON_AUTH",
        apiToken: CART_INITIAL_STATE.apiToken,
        shopHash: activeShop.id,
        clientId: String(couponClientId),
      },
      couponAppOrigin,
    );
  }, [activeShop?.id, couponAppOrigin, couponClientId]);

  useEffect(() => {
    const receiveMessage = (event) => {
      if (event.origin !== couponAppOrigin || event.source !== frameRef.current?.contentWindow) return;
      if (event.data?.type === "SNP_COUPON_READY") sendSession();
    };
    window.addEventListener("message", receiveMessage);
    return () => window.removeEventListener("message", receiveMessage);
  }, [sendSession]);

  return (
    <iframe
      ref={frameRef}
      src={couponEmbeddedUrl}
      title="Coupon Management"
      onLoad={sendSession}
      style={{ display: "block", width: "100%", height: "calc(100dvh - 96px)", border: 0, borderRadius: 0, background: "#f7f8fc" }}
    />
  );
};

export default CouponManagementFrame;
